import React from 'react';
import PropTypes from 'prop-types';

const LiteModeBanner = ({ isLiveVetEnabled }) => {
  return (
    <div>
      <h2>
        The Pet Portal is undergoing scheduled maintenance and we expect to be back online soon. <br />
        {isLiveVetEnabled && 'Live Vet is still available but please try again later for other features. '}
        Thank you for your patience.
      </h2>
    </div>
  );
};

export default LiteModeBanner;

LiteModeBanner.propTypes = {
  isLiveVetEnabled: PropTypes.bool
};
